import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

function UIUX_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <UIUX_FAQ/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <UIUX_FAQ/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function UIUX_FAQ(){
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>Why should I learn UI/UX Design?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          UI/UX skills are in high demand in tech, apps, websites, and digital products. Learning it opens career opportunities as UI/UX designer, product designer, or interaction designer.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>Do I need coding skills for UI/UX Design?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Basic coding knowledge helps but is not mandatory. UI/UX focuses more on design, user research, and prototyping.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What is a design system and why is it important?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          A design system is a collection of reusable components, guidelines, and standards. It ensures consistency, efficiency, and scalability in product design.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>Why is UI/UX design considered fast-growing fields?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          UI/UX design is expanding rapidly because businesses across industries are prioritizing digital platforms and customer experience. As users expect seamless, engaging, and accessible interfaces, the demand for skilled designers continues to rise. With the growth of mobile apps, e-commerce, SaaS, and emerging technologies like AR/VR and AI, UI/UX has become essential for product success, driving its fast growth worldwide.

          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>Can UI/UX Design skills be applied outside tech?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Yes! UI/UX principles are used in websites, mobile apps, digital products, e-commerce, and even physical products to improve user experience.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default UIUX_FAQ_page
